import { Alert, AlertIcon, AlertProps, AlertTitle } from '@chakra-ui/react';
import React from 'react';

export const CmAlert: React.FC<AlertProps> = ({
  children,
  status = 'info',
  ...rest
}) => {
  return (
    // @ts-ignore TS2590
    <Alert {...{ status, ...rest }}>
      <AlertIcon />
      <AlertTitle>{children}</AlertTitle>
    </Alert>
  );
};
